<template>
  <footer class="border-border-level-200 border-t dark:border-border-inverse/10 py-12">
    <div class="md:flex md:items-start md:justify-between">
      <div class="dark:text-content-level-400 text-content-level-600 text-left text-sm/6">
        <p>{{ $t('dashboard.messages.copyright', { currentYear }) }}</p>

        <I18nT
          scope="global"
          keypath="dashboard.messages.recaptchaProtection"
          tag="p"
          class="dark:text-content-level-500 mt-2 text-content-level-500 text-xs"
        >
          <template #privacyPolicy>
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              class="dark:hover:text-content-level-300 hover:text-content-level-700 underline"
            >
              {{ $t('dashboard.labels.privacyPolicy') }}
            </a>
          </template>

          <template #termsOfService>
            <a
              href="https://policies.google.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              class="dark:hover:text-content-level-300 hover:text-content-level-700 underline"
            >
              {{ $t('dashboard.labels.termsOfService') }}
            </a>
          </template>
        </I18nT>
      </div>

      <div class="flex flex-wrap gap-x-6 gap-y-2 md:justify-end md:mt-0 mt-4">
        <button
          type="button"
          class="dark:hover:text-content-inverse dark:text-content-level-400 hover:text-content-level-900 text-content-level-600 text-sm"
          data-testid="footer-privacy-policy"
          @click="openPrivacyPolicy"
        >
          {{ $t('dashboard.labels.privacyPolicy') }}
        </button>

        <button
          type="button"
          class="dark:hover:text-content-inverse dark:text-content-level-400 hover:text-content-level-900 text-content-level-600 text-sm"
          data-testid="footer-terms-conditions"
          @click="openTermsConditions"
        >
          {{ $t('dashboard.labels.termsConditions') }}
        </button>
      </div>
    </div>

    <LegalAgreementModal
      v-if="state.isOpen"
      v-model="isOpen"
      :agreement="state.agreement"
    />
  </footer>
</template>

<script setup lang="ts">
import LegalAgreementModal from '~/components/shared/legal/LegalAgreementModal.vue'
import { useUserAgreementModal } from '~/composables/useUserAgreementModal'

const currentYear = new Date().getFullYear()
const { isOpen, open, state } = useUserAgreementModal()

const openPrivacyPolicy = () => open('privacy_policy')
const openTermsConditions = () => open('terms_and_conditions')
</script>
